/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MigrateStateDialog.vue?vue&type=template&id=bfa96222&scoped=true"
import script from "./MigrateStateDialog.vue?vue&type=script&lang=js"
export * from "./MigrateStateDialog.vue?vue&type=script&lang=js"
import style0 from "./MigrateStateDialog.vue?vue&type=style&index=0&id=bfa96222&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa96222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa96222')) {
      api.createRecord('bfa96222', component.options)
    } else {
      api.reload('bfa96222', component.options)
    }
    module.hot.accept("./MigrateStateDialog.vue?vue&type=template&id=bfa96222&scoped=true", function () {
      api.rerender('bfa96222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/MigrateStateDialog.vue"
export default component.exports